<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_document" transform="translate(-448 -588)">
      <path
        id="패스_3897"
        data-name="패스 3897"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(448 588)"
      />
      <g id="그룹_8651" data-name="그룹 8651">
        <rect
          id="사각형_5792"
          data-name="사각형 5792"
          fill="#d5d8dc"
          width="18"
          height="18"
          rx="2"
          transform="translate(451 593)"
        />
        <path
          id="빼기_1"
          data-name="빼기 1"
          fill="#21bf54"
          d="M14,6H-4V4A2,2,0,0,1-2,2H2.171A3,3,0,0,1,7.829,2H12a2,2,0,0,1,2,2V6ZM5,2A1,1,0,1,0,6,3,1,1,0,0,0,5,2Z"
          transform="translate(455 589)"
        />
        <g id="그룹_8650" data-name="그룹 8650" transform="translate(-177 8.5)">
          <rect
            id="사각형_6104"
            data-name="사각형 6104"
            fill="#363c43"
            width="2"
            height="6"
            transform="translate(631 594.757) rotate(-45)"
          />
          <path
            id="패스_4065"
            data-name="패스 4065"
            fill="#363c43"
            d="M0,0,2.142-.02l-.1,10.708-2.142.02Z"
            transform="translate(641.471 590) rotate(45)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
